import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Account',
    data () {
        return {
            user: {},
            sellpoints:{},
            img_url: service.imageURL,
            user_business_interests: {},
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        syncset() {
            //get the ref from the url
            let navi = this.$router;
            service.sessionSyncSet(this, this.$route.params.id).then(response => {  //authenticate in server
                if(response.body.status == 200) {
                    let data = response.body.data;
                    //reset auths in locale 
                    localStorage.setItem("sp_user", data.user_name); 
                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    localStorage.setItem("sp_token_key", data.user_token_key);

                    //redirect to requested page
                    navi.push('/'+data.request);
                   
                }
            }).catch((err) => {
                if(err) {
                    console.log(err)
                    // this.$router.push('/');
                }
            })
                  
        },

    


    },
    created: function(){
        document.title = "Account" + " | SP";
        this.syncset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Manage/script.js